import { NEXT_GOOGLE_CLIENT_ID } from '@/shared/consts'

export const initiateOauthFlow = (
  provider: 'google',
  options: { silent?: boolean } = { silent: true },
) => {
  const currentOrigin = window.location.origin
  const redirectUri = `${currentOrigin}/auth/google-callback`

  const providerParams: Record<string, string> = {
    client_id: NEXT_GOOGLE_CLIENT_ID,
    response_type: 'code',
    redirect_uri: redirectUri,
    scope: 'email profile',
    access_type: 'offline',
  }

  if (options.silent !== undefined) {
    providerParams.prompt = options.silent ? 'none' : 'consent'
  }

  const url = `https://accounts.google.com/o/oauth2/v2/auth?${new URLSearchParams(providerParams)}`

  window.location.href = url
}
